const FAQ = [
  {
    question: "What is an ADU or garage conversion?",
    answer:
      "An ADU (Accessory Dwelling Unit) or garage conversion transforms an existing garage into a legal, livable space<IN_CITY_ZIP>, such as a guest house, rental unit, or home office. It's a great way to expand your usable square footage without building a new structure.",
  },
  {
    question: "Is my garage eligible for conversion?",
    answer:
      "Most attached and detached garages<IN_CITY_ZIP> are eligible for conversion, but it depends on local zoning, lot size, and access to utilities. We offer a free property assessment to determine feasibility and code compliance.",
  },
  {
    question: "Do you handle permits and engineering?",
    answer:
      "Yes. Modern Build manages the full process<IN_CITY_ZIP> — including architectural plans, structural engineering, permit submissions, and city inspections — to ensure your ADU conversion is fully legal and approved.",
  },
  {
    question: "How long does a garage conversion take?",
    answer:
      "Most ADU or garage conversion projects<IN_CITY_ZIP> take between 8 to 14 weeks from the start of construction, depending on the scope, permitting timelines, and material availability.",
  },
  {
    question: "What’s included in a typical ADU conversion?",
    answer:
      "A full ADU conversion<IN_CITY_ZIP> typically includes layout planning, framing, insulation, drywall, electrical and plumbing installation, HVAC, windows, flooring, cabinetry, and fixtures — everything needed to make the space livable.",
  },
  {
    question: "Can I rent out my converted ADU?",
    answer:
      "We ensure your ADU<IN_CITY_ZIP> meets all local building and habitability standards so it can be legally rented. We’ve helped dozens of homeowners in the area create compliant, income-producing units.",
  },
  {
    question: "Do I need to move out during construction?",
    answer:
      "In most cases, no. Garage conversions<IN_CITY_ZIP> are separate from the main house, so you can remain at home while we work. We'll coordinate scheduling to minimize disruption to your daily routine.",
  },
  {
    question: "Is financing available for ADU conversions?",
    answer:
      "Yes. We offer flexible financing options<IN_CITY_ZIP> with low monthly payments. Our team can help you explore programs that fit your budget during your free consultation.",
  },
  {
    question: "Why choose Modern Build for your garage conversion?",
    answer:
      "We're experienced in garage-to-ADU conversions<IN_CITY_ZIP>. From design and permitting to high-quality construction, we provide a turnkey process that delivers lasting value, comfort, and compliance.",
  },
    {
    question: "How much does a garage conversion cost?",
    answer:
      "Garage conversion costs<IN_CITY_ZIP> typically range from $80,000 to $150,000 depending on square footage, finishes, and whether plumbing or structural upgrades are needed. We provide clear, customized estimates during the consultation.",
  },
    {
    question: "Will converting my garage affect parking requirements?",
    answer:
      "In many California cities, garage conversions<IN_CITY_ZIP> are exempt from replacement parking requirements, especially near transit. We review your zoning and provide clarity during your free evaluation.",
  },
];

export default FAQ;
